import { Link } from "react-router-dom";
import { env } from "../config/env";
import type { UiKey } from "../i18n/ui";

type Props = {
  t: (key: UiKey) => string;
};

export function SiteFooter({ t }: Props) {
  return (
    <footer className="site-footer">
      <nav className="site-footer__nav" aria-label={t("nav.footerAria")}>
        <Link to="/">{t("nav.home")}</Link>
        <Link to="/how-it-works">{t("nav.howItWorks")}</Link>
        <Link to="/privacy">{t("nav.privacy")}</Link>
        <Link to="/terms">{t("nav.terms")}</Link>
      </nav>
      <p className="site-footer__line">{t("footer.note")}</p>
      <p className="site-footer__line site-footer__legal">{t("footer.legal")}</p>
      <p className="site-footer__line site-footer__contact">
        {t("footer.contactLead")}
        <a href={`mailto:${env.contactEmail}`} aria-label={t("footer.contactAria")}>
          {env.contactEmail}
        </a>
      </p>
      <style>{`
        .site-footer {
          margin-top: 2rem;
          padding-top: 1rem;
          border-top: 1px solid var(--border);
          font-size: 0.8rem;
          color: var(--muted);
        }
        .site-footer__nav {
          display: flex;
          flex-wrap: wrap;
          gap: 0.65rem 1.1rem;
          margin: 0 0 0.85rem;
        }
        .site-footer__nav a {
          color: var(--accent);
          text-decoration: none;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          min-height: 44px;
        }
        .site-footer__nav a:hover {
          text-decoration: underline;
        }
        .site-footer__line {
          margin: 0 0 0.5rem;
        }
        .site-footer__line:last-child {
          margin-bottom: 0;
        }
        .site-footer__legal {
          font-size: 0.72rem;
          line-height: 1.5;
          color: var(--muted);
          opacity: 0.95;
        }
        .site-footer__contact a {
          color: var(--accent);
          text-decoration: none;
          font-weight: 600;
        }
        .site-footer__contact a:hover {
          text-decoration: underline;
        }
      `}</style>
    </footer>
  );
}
